import * as CommonConstants from "../constants/CommonConstants";

export function setColAggregates_(owner, colId, Aggregates) {
    localStorage.setItem(calcColumnFullPath(owner, colId, "Aggregates"), Aggregates);
}

export function getColAggregates_(owner, colId) {
    return localStorage.getItem(calcColumnFullPath(owner, colId, "Aggregates"));
}

export function setColWidth(owner, e) {
    localStorage.setItem(calcColumnFullPath(owner, e.column.id, "width"), e.newWidth);
}

export function getColWidth(owner, filedId) {
    return parseFloat(localStorage.getItem(calcColumnFullPath(owner, filedId, "width")));
}

export function setColLocked(owner, e, locked) {
    localStorage.setItem(calcColumnFullPath(owner, e.column.id, "locked"), locked);
}

export function getColLocked(owner, filedId) {
    return localStorage.getItem(calcColumnFullPath(owner, filedId, "locked")) === "true";
}

export function setColHidden(owner, e, hidden) {
    localStorage.setItem(calcColumnFullPath(owner, e.column.id, "hidden"), hidden);
}

export function getColHidden(owner, filedId) {
    return localStorage.getItem(calcColumnFullPath(owner, filedId, "hidden"));
}

export function setColOrder(owner, colId, index) {
    localStorage.setItem(calcColumnFullPath(owner, colId, "order"), index);
}

export function getColOrder(owner, filedId) {
    return parseInt(localStorage.getItem(calcColumnFullPath(owner, filedId, "order")));
}

function calcColumnFullPath(owner, filedId, property) {
    if (!owner || !owner.place_ || !owner.layoutPrefix)
        return filedId + CommonConstants.SEPARATOR + property;
    let place = owner.place_();
    if (!place)
        return owner.layoutPrefix() + CommonConstants.SEPARATOR + owner.entityType + CommonConstants.SEPARATOR + filedId + CommonConstants.SEPARATOR + property;
    return owner.layoutPrefix() + CommonConstants.SEPARATOR + place.src + CommonConstants.SEPARATOR +
        place.listViewName + CommonConstants.SEPARATOR + place.entityType + CommonConstants.SEPARATOR +
        filedId + CommonConstants.SEPARATOR + property;
}

export function reorderColumns(owner, gridData) {
    setTimeout(() => {
        for (let i = 0; i < gridData.columns.length; i++) {
            setColOrder(owner, gridData.columns[i].id, i + 1);
        }
    }, 500);
}